export const QA_NAME_RENTAL_PORTAL_ARCHIVE_PAGE = 'rentalPortalArchive'

export const QA_NAME_RENTAL_PORTAL_ARCHIVE_REFRESH_ERROR =
  'rentalPortalArchiveRefreshError'

export const QA_NAME_RENTAL_PORTAL_ARCHIVE_RETRY = 'rentalPortalArchiveRetry'

export const RENTAL_PORTAL_ARCHIVE_PAGE_SIZE = 20

export const RENTAL_PORTAL_ARCHIVE_SKELETON_ROWS = 10

export const RENTAL_PORTAL_ARCHIVE_ACTION_RESTORE = 'restore'

export const RENTAL_PORTAL_ARCHIVE_ACTION_RESTORE_MASS = 'restoreMass'

export const RENTAL_PORTAL_ARCHIVE_OBJECT_TYPE = {
  listing: 'listing',
  viewing: 'viewing',
}

export const RENTAL_PORTAL_ARCHIVE_OBJECT_TYPES = {
  [RENTAL_PORTAL_ARCHIVE_OBJECT_TYPE.listing]: {
    label: 'RentalPortal.ArchiveObjectTypeListingKey',
    restoreNotAllowedTooltip: 'RentalPortal.ListingRestoreNotAllowedTooltipKey',
  },
  [RENTAL_PORTAL_ARCHIVE_OBJECT_TYPE.viewing]: {
    label: 'RentalPortal.ArchiveObjectTypeViewingKey',
    restoreNotAllowedTooltip: 'RentalPortal.ViewingRestoreNotAllowedTooltipKey',
  },
}

export const RENTAL_PORTAL_ARCHIVE_UNKNOWN_OBJECT_TYPE = {
  label: 'RentalPortal.ArchiveObjectTypeUnknownKey',
}

export const RENTAL_PORTAL_ARCHIVE_COLUMN_NAME = {
  ArchivedAt: 'archived_at',
  ObjectName: 'object_name',
  ObjectType: 'object_type',
  ResponsibleUser: 'responsible_user',
}

// TODO: the archive runs on fixed columns until the backend registers a table for it
export const RENTAL_PORTAL_ARCHIVE_COLUMNS = {
  [RENTAL_PORTAL_ARCHIVE_COLUMN_NAME.ArchivedAt]: {
    index: 2,
    name: RENTAL_PORTAL_ARCHIVE_COLUMN_NAME.ArchivedAt,
    title: 'RentalPortal.ArchiveArchivedAtColumnKey',
    visible: true,
    width: 160,
  },
  [RENTAL_PORTAL_ARCHIVE_COLUMN_NAME.ObjectName]: {
    index: 0,
    name: RENTAL_PORTAL_ARCHIVE_COLUMN_NAME.ObjectName,
    title: 'RentalPortal.ArchiveObjectColumnKey',
    visible: true,
    width: 360,
  },
  [RENTAL_PORTAL_ARCHIVE_COLUMN_NAME.ObjectType]: {
    index: 1,
    name: RENTAL_PORTAL_ARCHIVE_COLUMN_NAME.ObjectType,
    title: 'RentalPortal.ArchiveObjectTypeColumnKey',
    visible: true,
    width: 180,
  },
  [RENTAL_PORTAL_ARCHIVE_COLUMN_NAME.ResponsibleUser]: {
    index: 3,
    name: RENTAL_PORTAL_ARCHIVE_COLUMN_NAME.ResponsibleUser,
    title: 'RentalPortal.ArchiveResponsibleColumnKey',
    visible: true,
    width: 240,
  },
}

export const RENTAL_PORTAL_ARCHIVE_RESTORE_DESCRIPTION_KEYS_BY_TYPE = {
  [RENTAL_PORTAL_ARCHIVE_OBJECT_TYPE.listing]: [
    'RentalPortal.ListingRestoreConfirmationTextKey',
    'RentalPortal.ListingRestoreNoRepublishNoticeKey',
  ],
  [RENTAL_PORTAL_ARCHIVE_OBJECT_TYPE.viewing]: [
    'RentalPortal.ViewingRestoreConfirmationTextKey',
  ],
}

export const RENTAL_PORTAL_ARCHIVE_LISTINGS_REQUEST = {
  filters: { archived: true },
  size: 50,
}
